var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { LONGREAD_RESET_REQUESTED } from './updateLongReadPost';
import useCommonProps from "../hooks/useCommonProps";
import { useSelector } from "react-redux";
import { getCurrentLongread } from "../reducers/longreadBlocks";
export var LONG_READ_SPLIT = 'LONG_READ_SPLIT';
export var LONG_READ_DRAG_END = 'LONG_READ_DRAG_END';
export var LONG_READ_CONNECT = 'LONG_READ_CONNECT';
export function longreadDragEnd(blocks, currentId) {
    return function (dispatch) {
        dispatch({
            type: LONG_READ_DRAG_END,
            payload: {
                data: blocks,
                lgId: currentId
            }
        });
    };
}
export function longreadReset(lgId) {
    return function (dispatch) {
        dispatch({
            type: LONGREAD_RESET_REQUESTED,
            payload: {
                lgId: lgId
            }
        });
    };
}
export function longreadSplit(id, blockid, lgId) {
    return function (dispatch, getState) {
        var currState = getState();
        var blocksList = currState.longreadBlocks.blocks;
        // секция из которой удаляют
        var eltoRemove = blocksList.find(function (el) { return el.id === blockid; });
        var subitemIndexes = eltoRemove.answers.map(function (item, i) { return ({
            id: item.id,
            index: i
        }); });
        var subitemtoSplitBaseData = subitemIndexes.find(function (el) { return el.id === id; });
        // все сабитемы, которые будут в новом блоке
        var subitemtoSplit = eltoRemove.answers.slice(subitemtoSplitBaseData.index + 1, eltoRemove.answers.length);
        var subitemOld = eltoRemove.answers.slice(0, subitemtoSplitBaseData.index + 1);
        // старая и новая секция
        var elOld = __assign(__assign({}, eltoRemove), { answers: __spreadArray([], subitemOld, true) });
        var elNew = __assign(__assign({}, eltoRemove), { id: "question-".concat(Math.random()), answers: __spreadArray([], subitemtoSplit, true) });
        // ищем куда вставить новую секцию
        var blocksListIndexes = blocksList.map(function (item, i) { return ({
            id: item.id,
            index: i
        }); });
        var eltoSplitBaseData = blocksListIndexes.find(function (el) { return el.id === blockid; });
        // всталяем
        var newBlockList = __spreadArray([], blocksList, true);
        newBlockList.splice(eltoSplitBaseData.index, 1, elOld, elNew);
        dispatch({
            type: LONG_READ_SPLIT,
            payload: {
                data: newBlockList,
                lgId: lgId
            }
        });
    };
}
export function longreadConnect(id) {
    return function (dispatch, getState) {
        var currState = getState();
        var blocksList = currState.longreadBlocks.blocks;
        var blocksListIndexes = blocksList.map(function (item, i) { return ({
            id: item.id,
            index: i
        }); });
        // элемент, в который добавляет
        var eltoAdd = blocksList.find(function (el) { return el.id === id; });
        var eltoAddBaseData = blocksListIndexes.find(function (el) { return el.id === id; });
        // элемент добавляемый
        var elAdded = blocksList[eltoAddBaseData.index + 1];
        // новый элемент из двух предыдущих
        var elNew = __assign(__assign({}, eltoAdd), { answers: __spreadArray(__spreadArray([], eltoAdd.answers, true), elAdded.answers, true) });
        // blocksList.splice(eltoAddBaseData.index, 2, elNew)
        var newBlockList = __spreadArray([], blocksList, true);
        newBlockList.splice(eltoAddBaseData.index, 2, elNew);
        dispatch({
            type: LONG_READ_CONNECT,
            payload: newBlockList
        });
    };
}
//# sourceMappingURL=longreadblocks.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { LONGREAD_RESET_REQUESTED } from './updateLongReadPost';
import useCommonProps from "../hooks/useCommonProps";
import { useSelector } from "react-redux";
import { getCurrentLongread } from "../reducers/longreadBlocks";
export var LONG_READ_SPLIT = 'LONG_READ_SPLIT';
export var LONG_READ_DRAG_END = 'LONG_READ_DRAG_END';
export var LONG_READ_CONNECT = 'LONG_READ_CONNECT';
export function longreadDragEnd(blocks, currentId) {
    return function (dispatch) {
        dispatch({
            type: LONG_READ_DRAG_END,
            payload: {
                data: blocks,
                lgId: currentId
            }
        });
    };
}
export function longreadReset(lgId) {
    return function (dispatch) {
        dispatch({
            type: LONGREAD_RESET_REQUESTED,
            payload: {
                lgId: lgId
            }
        });
    };
}
export function longreadSplit(id, blockid, lgId) {
    return function (dispatch, getState) {
        var currState = getState();
        var blocksList = currState.longreadBlocks.blocks;
        // секция из которой удаляют
        var eltoRemove = blocksList.find(function (el) { return el.id === blockid; });
        var subitemIndexes = eltoRemove.answers.map(function (item, i) { return ({
            id: item.id,
            index: i
        }); });
        var subitemtoSplitBaseData = subitemIndexes.find(function (el) { return el.id === id; });
        // все сабитемы, которые будут в новом блоке
        var subitemtoSplit = eltoRemove.answers.slice(subitemtoSplitBaseData.index + 1, eltoRemove.answers.length);
        var subitemOld = eltoRemove.answers.slice(0, subitemtoSplitBaseData.index + 1);
        // старая и новая секция
        var elOld = __assign(__assign({}, eltoRemove), { answers: __spreadArray([], subitemOld, true) });
        var elNew = __assign(__assign({}, eltoRemove), { id: "question-".concat(Math.random()), answers: __spreadArray([], subitemtoSplit, true) });
        // ищем куда вставить новую секцию
        var blocksListIndexes = blocksList.map(function (item, i) { return ({
            id: item.id,
            index: i
        }); });
        var eltoSplitBaseData = blocksListIndexes.find(function (el) { return el.id === blockid; });
        // всталяем
        var newBlockList = __spreadArray([], blocksList, true);
        newBlockList.splice(eltoSplitBaseData.index, 1, elOld, elNew);
        dispatch({
            type: LONG_READ_SPLIT,
            payload: {
                data: newBlockList,
                lgId: lgId
            }
        });
    };
}
export function longreadConnect(id) {
    return function (dispatch, getState) {
        var currState = getState();
        var blocksList = currState.longreadBlocks.blocks;
        var blocksListIndexes = blocksList.map(function (item, i) { return ({
            id: item.id,
            index: i
        }); });
        // элемент, в который добавляет
        var eltoAdd = blocksList.find(function (el) { return el.id === id; });
        var eltoAddBaseData = blocksListIndexes.find(function (el) { return el.id === id; });
        // элемент добавляемый
        var elAdded = blocksList[eltoAddBaseData.index + 1];
        // новый элемент из двух предыдущих
        var elNew = __assign(__assign({}, eltoAdd), { answers: __spreadArray(__spreadArray([], eltoAdd.answers, true), elAdded.answers, true) });
        // blocksList.splice(eltoAddBaseData.index, 2, elNew)
        var newBlockList = __spreadArray([], blocksList, true);
        newBlockList.splice(eltoAddBaseData.index, 2, elNew);
        dispatch({
            type: LONG_READ_CONNECT,
            payload: newBlockList
        });
    };
}
//# sourceMappingURL=longreadblocks.js.map